import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  sectionTitle: {
    id: 'lQQKOx',
    defaultMessage: 'Packing Recommendations',
    description: 'Title for the packing recommendations settings section',
  },
  infoBanner: {
    id: 'L+Zi70',
    defaultMessage:
      'Setup required for accurate recommendations. Add dimensions and weights to your products, and configure your custom packages in Shipping Settings.',
    description: 'Info banner text explaining setup requirements for packing recommendations',
  },
  dropdownLabel: {
    id: 'iQ6NSh',
    defaultMessage: 'Make recommendation based on',
    description: 'Label for the optimization factor dropdown in packing recommendations',
  },
  fewestBoxes: {
    id: 'zlH22I',
    defaultMessage: 'Fewest boxes',
    description: 'Dropdown option to optimize packing recommendations by fewest boxes',
  },
  weightDistribution: {
    id: 'H/uz4o',
    defaultMessage: 'Weight distribution',
    description: 'Dropdown option to optimize packing recommendations by weight distribution',
  },
  shipmentPrice: {
    id: 'CwkmEq',
    defaultMessage: 'Shipment price',
    description: 'Dropdown option to optimize packing recommendations by shipment price',
  },
  toggleError: {
    id: 'UkkRs6',
    defaultMessage: 'Failed to update packing recommendations. Please try again.',
    description: 'Error notification when toggling packing recommendations fails',
  },
});
